import React, { useState } from 'react';
import { Bell, ChevronDown, Wallet as WalletIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';

const Topbar = ({ count, sort, setSort, inStockOnly, setInStockOnly, onDeposit, title = 'INVENTORY', subtitleUnit = 'Units' }) => {
  const { notifications, markAllRead } = useApp();
  const [openNotif, setOpenNotif] = useState(false);
  const unread = notifications.filter((n) => n.unread).length;

  return (
    <div className="flex items-center justify-between px-8 py-5 border-b border-[#151515] bg-[#050505] sticky top-0 z-20">
      <div>
        <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">{title}</div>
        <div className="text-2xl font-mono text-[#e6e6e6] mt-0.5">
          {count} <span className="text-[11px] tracking-[0.25em] text-[#5a5a5a] ml-1">{subtitleUnit}</span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {typeof setSort === 'function' && (
          <div className="relative">
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="appearance-none bg-transparent border border-[#1f1f1f] hover:border-[#2a2a2a] text-[11px] tracking-[0.2em] text-[#e6e6e6] pl-3 pr-8 py-2 rounded-md font-mono outline-none cursor-pointer"
            >
              <option value="NEWEST_FIRST" className="bg-[#0a0a0a]">NEWEST_FIRST</option>
              <option value="PRICE_LOW" className="bg-[#0a0a0a]">PRICE_LOW</option>
              <option value="PRICE_HIGH" className="bg-[#0a0a0a]">PRICE_HIGH</option>
              <option value="STOCK_HIGH" className="bg-[#0a0a0a]">STOCK_HIGH</option>
            </select>
            <ChevronDown size={12} className="absolute right-2 top-1/2 -translate-y-1/2 text-[#5a5a5a] pointer-events-none" />
          </div>
        )}

        {typeof setInStockOnly === 'function' && (
          <button
            onClick={() => setInStockOnly(!inStockOnly)}
            className={`text-[11px] tracking-[0.2em] px-3 py-2 rounded-md border font-mono transition-colors ${
              inStockOnly ? 'border-[#22c55e] text-[#22c55e] bg-[#0f1a12]' : 'border-[#1f1f1f] text-[#8a8a8a] hover:border-[#2a2a2a] hover:text-[#e6e6e6]'
            }`}
          >IN_STOCK_ONLY</button>
        )}

        <div className="relative">
          <button
            onClick={() => { setOpenNotif((v) => !v); }}
            className="relative p-2 border border-[#1f1f1f] rounded-md hover:border-[#2a2a2a] transition-colors"
          >
            <Bell size={15} className="text-[#8a8a8a]" />
            {unread > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 text-[9px] rounded-full bg-[#22c55e] text-black font-mono flex items-center justify-center">{unread}</span>
            )}
          </button>
          {openNotif && (
            <>
              <div className="fixed inset-0 z-30" onClick={() => setOpenNotif(false)} />
              <div className="absolute right-0 mt-2 w-[320px] bg-[#0a0a0a] border border-[#1f1f1f] rounded-md shadow-xl z-40 overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b border-[#151515]">
                  <span className="text-[11px] tracking-[0.2em] text-[#8a8a8a]">NOTIFICATIONS</span>
                  <button onClick={markAllRead} className="text-[10px] tracking-[0.2em] text-[#22c55e] hover:underline">MARK ALL READ</button>
                </div>
                <div className="max-h-[320px] overflow-y-auto">
                  {notifications.map((n) => (
                    <div key={n.id} className="px-4 py-3 border-b border-[#0f0f0f] last:border-0 hover:bg-[#0d0d0d]">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1">
                          <div className="text-[12px] text-[#e6e6e6] flex items-center gap-2">
                            {n.unread && <span className="w-1.5 h-1.5 rounded-full bg-[#22c55e]" />}
                            {n.title}
                          </div>
                          <div className="text-[11px] text-[#7a7a7a] mt-0.5">{n.body}</div>
                        </div>
                        <span className="text-[10px] text-[#4a4a4a] whitespace-nowrap">{n.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>

        <button
          onClick={onDeposit}
          className="flex items-center gap-2 text-[11px] tracking-[0.2em] px-3.5 py-2 rounded-md border border-[#22c55e] text-[#22c55e] hover:bg-[#0f1a12] transition-colors font-mono"
        >
          <WalletIcon size={13} /> DEPOSIT
        </button>
      </div>
    </div>
  );
};

export default Topbar;
